import { defineComponent as _defineComponent } from 'vue'
import {
  inject,
  markRaw,
  ref,
  watch,
  toRef,
  onBeforeUnmount,
  useListeners,
} from 'vue'

import { apiSymbol, mapSymbol } from '@/components/core/map/utils'

type MapPolylineEvents = {
  (e: 'click', event: google.maps.PolyMouseEvent): void
  (e: 'contextmenu', event: google.maps.PolyMouseEvent): void
  (e: 'dblclick', event: google.maps.PolyMouseEvent): void
  (e: 'drag', event: google.maps.MapMouseEvent): void
  (e: 'dragend', event: google.maps.MapMouseEvent): void
  (e: 'dragstart', event: google.maps.MapMouseEvent): void
  (e: 'mousedown', event: google.maps.PolyMouseEvent): void
  (e: 'mouseout', event: google.maps.PolyMouseEvent): void
  (e: 'mousemove', event: google.maps.PolyMouseEvent): void
  (e: 'mouseover', event: google.maps.PolyMouseEvent): void
  (e: 'mouseup', event: google.maps.PolyMouseEvent): void
}

export interface MapPolylineProps {
  options: google.maps.PolylineOptions
  hide?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MapPolyline',
  props: {
    options: null,
    hide: { type: Boolean }
  },
  emits: ["click", "contextmenu", "dblclick", "drag", "dragend", "dragstart", "mousedown", "mouseout", "mousemove", "mouseover", "mouseup"],
  setup(__props: any, { expose }: { emit: ({
  (e: 'click', event: google.maps.PolyMouseEvent): void
  (e: 'contextmenu', event: google.maps.PolyMouseEvent): void
  (e: 'dblclick', event: google.maps.PolyMouseEvent): void
  (e: 'drag', event: google.maps.MapMouseEvent): void
  (e: 'dragend', event: google.maps.MapMouseEvent): void
  (e: 'dragstart', event: google.maps.MapMouseEvent): void
  (e: 'mousedown', event: google.maps.PolyMouseEvent): void
  (e: 'mouseout', event: google.maps.PolyMouseEvent): void
  (e: 'mousemove', event: google.maps.PolyMouseEvent): void
  (e: 'mouseover', event: google.maps.PolyMouseEvent): void
  (e: 'mouseup', event: google.maps.PolyMouseEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  options: google.maps.PolylineOptions
  hide?: boolean
};

const defaultOptions: google.maps.PolylineOptions = {
  geodesic: true,
  strokeColor: '#FFC94A',
  strokeOpacity: 1.0,
  strokeWeight: 3,
}




const map = inject(mapSymbol, ref())
const api = inject(apiSymbol, ref())

const listeners = useListeners()

const options = toRef(props, 'options')
const polyline = ref<google.maps.Polyline>()

watch(
  () => props.hide,
  (hide) => {
    if (polyline.value) {
      polyline.value.setMap(hide ? null : map.value ?? null)
    }
  },
)

watch(
  [map, options],
  async ([newMap]) => {
    if (!newMap) {
      return
    }

    if (polyline.value) {
      polyline.value.setOptions(options.value)
    } else {
      const { Polyline } = (await google.maps.importLibrary(
        'maps',
      )) as google.maps.MapsLibrary

      polyline.value = markRaw(
        new Polyline({
          ...defaultOptions,
          ...options.value,
          map: props.hide ? null : map.value,
        }),
      )

      Object.entries(listeners).forEach(([key, handler]) => {
        const handlers = Array.isArray(handler) ? handler : [handler]
        for (const handler of handlers) {
          polyline.value?.addListener(key, handler)
        }
      })
    }
  },
  { immediate: true },
)

onBeforeUnmount(() => {
  if (polyline.value) {
    api.value?.event.clearInstanceListeners(polyline.value)
    polyline.value.setMap(null)
  }
})

expose({ polyline })

return { __sfc: true,defaultOptions, props, map, api, listeners, options, polyline }
}

})